/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import { TextField, Button, Grid } from "@mui/material";
import { INewsCategoryForm } from "../INewsCategory";
import { Form, Field } from "react-final-form";
import { setIn } from "final-form";
import * as yup from "yup";
import { ADD, header } from "../../../../context/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { newsCategoryPath } from "../../../../sitemap";
import toast, { Toaster } from "react-hot-toast";
import addNewsCategoryServices from "../../../../api/Website/NewsCategory/AddNewsCategory/addNewsCategoryServices";
import editNewsCategoryService from "../../../../api/Website/NewsCategory/EditNewsCategory/editNewsCategoryService";

export interface addPolicyTypeFormProps {
  initialValues: INewsCategoryForm;
}

const AddNewsCategoryForm = (props: addPolicyTypeFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { initialValues } = props;
  const navigate = useNavigate();
  const location = useLocation() as any;
  const pathName = location.pathname.split("/");
  const isAddEdit = pathName[pathName.length - 1] as string;
  const isAdd = isAddEdit === ADD;

  // To be passed to React Final Form
  const validateFormValues = (schema: any) => async (values: any) => {
    if (typeof schema === "function") {
      schema = schema();
    }
    try {
      await schema.validate(values, { abortEarly: false });
    } catch (err: any) {
      const errors = err.inner.reduce((formError: any, innerError: any) => {
        return setIn(formError, innerError.path, innerError.message);
      }, {});

      return errors;
    }
  };

  const validationSchema = yup.object().shape({
    category: yup
      .string()
      .required("Category Name is required")
      .min(1, "Category must be at least 1 character")
      .max(100, "Category cannot exceed 100 characters"),
  });

  const validate = validateFormValues(validationSchema);

  const onSubmit = async (category: INewsCategoryForm) => {
    if (isAdd) {
      callAddCategoryAPI(category);
    } else {
      callEditCategoryAPI(category);
    }
  };

  const navigateToCategories = (message: string) => {
    navigate(newsCategoryPath(), {
      state: message,
    });
  };

  const callAddCategoryAPI = async (category: INewsCategoryForm) => {
    try {
      setIsLoading(true);
      const newCategory = await addNewsCategoryServices({ header, category });
      navigateToCategories(`${newCategory.message}`);
    } catch (error: any) {
      const err = await error;
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const callEditCategoryAPI = async (category: INewsCategoryForm) => {
    try {
      setIsLoading(true);
      const newCategory = await editNewsCategoryService({ header, category });
      navigateToCategories(`${newCategory.message}`);
    } catch (error: any) {
      const err = await error;
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validate}
        render={({ handleSubmit, submitting, errors }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={2}>
              <Grid item sm={12}>
                <Field name="category">
                  {({ input, meta }) => (
                    <TextField
                      {...input}
                      label="Enter Category Name"
                      type="text"
                      variant="outlined"
                      className="rounded-sm w-full"
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  disabled={isLoading}
                  variant="contained"
                  color="primary"
                  className=" w-26 h-10 bg-addButton text-white p-3 text-xs rounded-sm"
                >
                  {isLoading
                    ? "Submitting..."
                    : isAdd
                    ? "Add Category"
                    : "Update Category"}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <Toaster position="bottom-center" reverseOrder={false} />
    </>
  );
};

export default AddNewsCategoryForm;
